import axios from "axios";
import ReactOnRails from "react-on-rails";

let jwtToken = localStorage.getItem("jwtToken");

export const instance = axios.create({
  headers: {
    ...ReactOnRails.authenticityHeaders({}),
  },
});

instance.interceptors.request.use((config) => {
  if (jwtToken) {
    config.headers.Authorization = `Bearer ${jwtToken}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = "/session/new";
    }
    return Promise.reject(error);
  }
);

export const setJwtToken = (token) => {
  localStorage.setItem("jwtToken", token);
  jwtToken = token;
};
